import { az } from './az';
import { en } from './en';
import { ru } from './ru';
import { tr } from './trTR';
import { Language } from '../contexts/LanguageContext';

export interface Translations {
  [key: string]: string | Translations;
}

const translations: Record<Language, Translations> = {
  az,
  en,
  ru,
  tr,
};

export default translations;

